import { ReactNode } from 'react';
import { WrongNetwork } from './components/WrongNetwork';
import { useWrongNetwork } from './components/WrongNetwork/hooks/useWrongNetwork';
import { TChainId } from 'modules/api';

interface IWrongNetworkGuardProps {
  children: ReactNode;
  expectedChainIds?: TChainId[];
}

export function WrongNetworkGuard({
  expectedChainIds,
  children,
}: IWrongNetworkGuardProps): JSX.Element {
  const isWrongNetwork = useWrongNetwork(expectedChainIds);

  if (isWrongNetwork && expectedChainIds) {
    return <WrongNetwork expectedChainIds={expectedChainIds} />;
  }

  return <>{children}</>;
}
